import React, { useState } from "react";
import Collapsible from "react-collapsible";

const MobileTableItem = (props) => {
  const [IsOpen, setIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const replaceUnavailableProperty = (Property) => {
    if (Property === null || Property === undefined) {
      return <p className="unavailable-property">({translateText("not_available")})</p>;
    } else {
      return Property;
    }
  };

  const shortenTitle = (Title) => {
    if (Title.length < 40) {
      return Title;
    } else {
      let Short = Title.slice(0, 36) + " ...";
      return (
        <>
          <span className="popup-text">{Title}</span>
          {Short}
        </>
      );
    }
  };

  const selectJPACode = () => {
    if (props.SelectedJPAType === "Vacancies") {
      return props.RowItem.globalPositionCode;
    } else if (props.SelectedJPAType === "Projects") {
      return props.RowItem.globalProjectCode;
    } else if (props.SelectedJPAType === "Activities") {
      return props.RowItem.globalActivityCode;
    }
  };

  return (
    <div className="mobile-row-item is-mobile">
      <section className="row-main-info">
        <p>
          <span onClick={() => props.NavigateToJPADetail()}>
            {shortenTitle(props.RowItem.title)}
          </span>
        </p>
        <p>{"(" + selectJPACode() + ")"}</p>
      </section>
      <Collapsible
        onOpening={() => setIsOpen(true)}
        onClosing={() => setIsOpen(false)}
        trigger={
          <span
            className={
              IsOpen ? "circle-indidcator rotated" : "circle-indidcator"
            }
          >
            <i className="feather-chevron-down"></i>
          </span>
        }
      >
        <>
          {props.LangData ? (
            <section className="mobile-row-item-content">
              <span>
                <p>{translateText("location")}</p>
                <p>{replaceUnavailableProperty(props.RowItem.workCity)}</p>
              </span>
              <span>
                <p>{translateText("hiring_manager")}</p>
                <p>{replaceUnavailableProperty(`${props.RowItem.hrFirstName} ${props.RowItem.hrLastName}`)}</p>
              </span>
              <span>
                <p>{translateText("language")}</p>
                <p>{replaceUnavailableProperty(props.RowItem.languages)}</p>
              </span>
              {props.IsStatus ? null : (
                <>
                  <span>
                    <p>
                      <i className="feather-thumbs-up"></i>
                    </p>
                    <p>
                      {replaceUnavailableProperty(props.RowItem.totalLikes)}
                    </p>
                  </span>
                  <span>
                    <p>
                      <i className="feather-thumbs-down"></i>
                    </p>
                    <p>
                      {replaceUnavailableProperty(props.RowItem.totalDislikes)}
                    </p>
                  </span>
                  <span>
                    <p>
                      <i className="feather-bookmark"></i>
                    </p>
                    <p>
                      {replaceUnavailableProperty(props.RowItem.totalBookmarks)}
                    </p>
                  </span>
                </>
              )}
              <span>
                <p>{translateText("jpa_status_applied")}</p>
                <p>
                  {replaceUnavailableProperty(props.RowItem.totalApplications)}
                </p>
              </span>
            </section>
          ) : null}
        </>
      </Collapsible>
    </div>
  );
};

export default MobileTableItem;
